import { Observable, Subject } from 'rxjs';

import { WizardResultStep } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-result-step';
import { ResultCustomFormGroup } from '../../../../ui/custom-reactive-forms/result-custom-form-group';
import { InsuranceSportCreateWizardComponent } from '../insurance-sport-create-wizard.component';
import { InsuranceSportConfirmDoneData } from '../insurance-sport-create-wizard.model';
import { InsuranceSportCreateWizardResultForm } from '../result-form/insurance-sport-create-wizard-result-form';


export class InsuranceSportCreateWizardThirdStep extends WizardResultStep<InsuranceSportCreateWizardComponent> {

	public onInit(resultData: InsuranceSportConfirmDoneData): Observable<void> {
		return Observable.create((observer: Subject<void>) => {
			this.form = this.buildResultForm(resultData);
			this.buildResultStep();
			observer.next();
		});
	}

	protected buildResultStep(): void {
		this.stepInformation.resultDescription.next('Страховой полис оформлен');
	}

	protected buildResultForm(resultData: InsuranceSportConfirmDoneData): ResultCustomFormGroup {
		return new InsuranceSportCreateWizardResultForm().buildResultForm(resultData);
	}

}
